import { asyncFormValidation } from '@/element-ui/form-utils'
import _ from 'lodash'

export default {
  name: 'activate-search-bar',
  components: {
  },
  props: {
  },
  data () {
    return {
      model: {
        searchText: ''
      }
    }
  },
  methods: {
    async handleSubmitForm () {
      const isFormValid = await asyncFormValidation(this.$refs.refActivateSearchBarForm)

      if (!isFormValid) {
        return
      }
      this.$emit('onSubmit', this.model.searchText.trim())
    },
    debouncedSearch: _.debounce(async function () {
      this.$emit('input', this.model.searchText.trim())
    }, 500),
    handleInputChange () {
      this.debouncedSearch()
    }
  },
  mounted () {}
}
